import { AccredibleResponsiveMenuItem } from '@accredible-frontend-v2/components/responsive-menu';
import { AccredibleLanguageService } from '@accredible-frontend-v2/services/language';
import { Component } from '@angular/core';

const TRANSLATION_KEY = 'expertsdirectory_cloudinary_com.header';

@Component({
  templateUrl: './header.component.html',
  styleUrls: [`./header.component.scss`],
})
export class HeaderComponent {
  extraHeaderLinks: AccredibleResponsiveMenuItem[] = [
    {
      id: 'rmi-cloudinary-academy',
      label: this._language.selectTranslate(`${TRANSLATION_KEY}.cloudinary_academy`),
      externalLink: 'https://training.cloudinary.com/',
    },
    {
      id: 'rmi-become-partner',
      label: this._language.selectTranslate(`${TRANSLATION_KEY}.become_partner`),
      externalLink: 'https://cloudinary.com/partners#become-partner',
    },
    {
      id: 'rmi-contact-us',
      label: this._language.selectTranslate(`${TRANSLATION_KEY}.contact_us`),
      externalLink: 'https://cloudinary.com/contact',
    },
  ];

  constructor(private readonly _language: AccredibleLanguageService) {}
}
